import React from 'react';
import PropTypes, { InferProps } from 'prop-types';
import styled from '@emotion/styled';
import breakpoints from '../Theme/breakpoints';
import { Breadcrumbs } from '../Breadcrumb';
import Headline3 from '../Typography/Heading/Headline3';
import { Grid, GridCell } from '../Grid';

export const ArticlesContainer = styled.div`
  margin: 0 auto 32px;
  max-width: 970px;
  box-sizing: border-box;
  width: 100%;
  padding: 0 16px;

  @media (min-width: ${breakpoints.lg}px) {
    margin: 0 auto 48px;
    padding: 0;
  }
`;

export const ArticlesListCheckboxWrapper = styled.div`
  margin: 24px 0 -24px -12px;
`;

const ArticleListWrapper = styled.div<{ hasSidebar: boolean }>`
  display: grid;
  @media (min-width: ${breakpoints.lg}px) {
    ${({ hasSidebar }) => hasSidebar && 'grid-template-columns: 634px 344px'}
  }
`;

const ArticleListContainer = styled.div`
  max-width: 100%;
`;

const SidebarContainer = styled.div`
  padding: 8px 0 0 8px;
  display: none;
  @media (min-width: ${breakpoints.lg}px) {
    display: block;
  }
`;

const articlesListPagePropertyTypes = {
  title: PropTypes.string.isRequired,
  breadcrumbs: PropTypes.arrayOf(PropTypes.node).isRequired,
  topSlot: PropTypes.node,
  searchFields: PropTypes.node,
  featuredBlock: PropTypes.node,
  children: PropTypes.node,
  sidebar: PropTypes.node,
};

type ArticlesListPageProperties = InferProps<
  typeof articlesListPagePropertyTypes
>;

const ArticleListPage = ({
  breadcrumbs,
  title,
  topSlot,
  searchFields,
  children,
  sidebar,
  featuredBlock,
}: ArticlesListPageProperties) => (
  <ArticlesContainer>
    <Grid container spacing={0}>
      <GridCell padding="0 4px 20px 4px">
        <Breadcrumbs crumbs={breadcrumbs} />
      </GridCell>
      {featuredBlock && (
        <GridCell padding="0 0 20px">
          {featuredBlock}
        </GridCell>
      )}
      <GridCell padding="4px 0">
        <Headline3 tag="h1">
          {title}
        </Headline3>
      </GridCell>
      {topSlot && (
        <GridCell>
          {topSlot}
        </GridCell>
      )}
      {searchFields && (
        <GridCell padding="0 0 20px">
          {searchFields}
        </GridCell>
      )}
      <GridCell padding="0 0 20px">
        <ArticleListWrapper hasSidebar={Boolean(sidebar)}>
          <ArticleListContainer>
            { children }
          </ArticleListContainer>
          { sidebar && (
            <SidebarContainer className="sidebar-container">
              {sidebar}
            </SidebarContainer>
          )}
        </ArticleListWrapper>
      </GridCell>
    </Grid>
  </ArticlesContainer>
);

ArticleListPage.propTypes = articlesListPagePropertyTypes;

export default ArticleListPage;
